import { observer } from "mobx-react"
import Image from "next/image"
import parse from "react-html-parser"
import { ButtonContained } from "@ui"
import { useStore } from "@features/common"
import IconApplicationBannerAction from "@assets/media/application-banner-action-icon.svg"

export const ApplicationBanner = observer(function ApplicationBanner(
  props: import("@serializers/article").ArticleBannerStructure,
) {
  const {
    background_color: backgroundColor,
    title,
    action_text,
    picture,
    playmarket_button_text,
    appgallery_button_text,
  } = props
  const { ResponsiveModel } = useStore()

  const onBannerClick = () => {
    if (!ResponsiveModel.isAndroid) {
      location.href = "https://pureapp.onelink.me/M5p9/07ss1h1b"
    }
  }

  return (
    <section
      className="relative tablet:flex desktop:py-[17px]"
      style={{ backgroundColor }}
      onClick={onBannerClick}
      data-test-id="article__banner"
    >
      <div className="px-4 py-10 box-content flex-shrink-0 tablet:w-[360px] tablet:py-12 tablet:pl-10 desktop:w-170">
        <h4 className="text-3xl leading-9 text-center uppercase tracking-2 mb-[238px] tablet:mb-0 tablet:text-left">
          {parse(title)}
        </h4>
        {ResponsiveModel.isAndroid ? (
          <div className="space-x-2 flex mt-6 desktop:max-w-sm">
            <ButtonContained
              as="a"
              href="https://pureapp.onelink.me/M5p9/07ss1h1b"
              className="pt-2 pb-1 h-12 w-1/2 text-lg mobile-m:text-xl leading-normal"
              data-test-id="article__banner__googleplay_button"
            >
              {parse(playmarket_button_text)}
            </ButtonContained>
            <ButtonContained
              as="a"
              href="https://pureapp.onelink.me/M5p9/a8id7d4m"
              className="pt-2 pb-1 h-12 w-1/2 text-lg mobile-m:text-xl leading-normal"
              data-test-id="article__banner__appgallery_button"
            >
              {parse(appgallery_button_text)}
            </ButtonContained>
          </div>
        ) : (
          <div className="space-x-2 tablet:space-x-0 mt-6 flex w-full justify-center items-center tablet:justify-start">
            <IconApplicationBannerAction className="w-7 h-7 block flex-shrink-0 tablet:hidden" />
            <ButtonContained
              as="a"
              href="https://pureapp.onelink.me/M5p9/07ss1h1b"
              className="pt-2 pb-1 h-12 min-w-52 mobile-m:min-w-[16.875rem] tablet:min-w-[21.25rem] desktop:min-w-[420px] text-xl leading-normal"
              data-test-id="article__banner__button"
            >
              {parse(action_text)}
            </ButtonContained>
            <IconApplicationBannerAction className="w-7 h-7 block flex-shrink-0 tablet:hidden" />
          </div>
        )}
      </div>
      <div className="absolute w-full left-0 bottom-[114px] tablet:static tablet:flex tablet:items-center tablet:pr-6 desktop:pr-0">
        <figure className="relative w-[328px] h-[206px] mx-auto">
          <Image
            src={picture.url}
            layout="fill"
            alt={picture.alternativeText}
            objectFit="cover"
          />
        </figure>
      </div>
    </section>
  )
})
